import React, { useState, useEffect, useContext } from "react";
import { FaFilePdf } from "react-icons/fa";
import LoadingCircle from "../utility/LoadingCircle";
import { isMobile } from "react-device-detect";
import LocalPDFViewer from "../project/camera/LocalPDFViewer";
import UserContext from "../User/UserContext";

const useFetchPdf = (url) => {
	const [pdfUrl, setPdfUrl] = useState(null);

	useEffect(() => {
		fetch(url)
			.then((response) => response.blob())
			.then((blob) => {
				const objectUrl = URL.createObjectURL(blob);
				setPdfUrl(objectUrl);
			})
			.catch((error) => {});
	}, [url]);

	return pdfUrl;
};

const PdfViewer = ({ dropboxUrl, title, path }) => {
	const { api, token } = useContext(UserContext);
	const [isOpen, setIsOpen] = useState(false);
	const pdfUrl = useFetchPdf(dropboxUrl);

	const handleOpenClick = () => {
		setIsOpen(true);
	};

	const handleCloseClick = () => {
		setIsOpen(false);
	};

	return (
		<div className="flex gap-2 items-center">
			{pdfUrl ? (
				<button onClick={handleOpenClick}>
					<FaFilePdf className="h-10 w-10" color="red" />
				</button>
			) : (
				<LoadingCircle />
			)}
			<div>
				<button onClick={handleOpenClick}>{title}</button>
				{isOpen ? <LocalPDFViewer api={api} closeAction={handleCloseClick} dropboxPath={path} token={token} /> : null}
			</div>
		</div>
	);
};

export default PdfViewer;
